export const asyncOpenInNew = async (
  pathPromise: Promise<string>,
  loadingText = 'Generating your document, please wait...'
) => {
  const newTab = window.open('', '_blank');
  if (!newTab) {
    throw new Error(
      'Unable to open new window for PDF generation. Please allow popups in your browser settings.'
    );
  }
  newTab.document.write(`<p>${loadingText}</p>`);

  return pathPromise
    .then((path) => {
      newTab.location.href = path;
    })
    .catch((err) => {
      newTab.close();
      throw err;
    });
};
